import { render } from "./KnowledgebaseEdit.vue?vue&type=template&id=8046ec40"
import script from "./KnowledgebaseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgebaseEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Knowledgebase/KnowledgebaseEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8046ec40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8046ec40', __exports__)) {
    api.reload('8046ec40', __exports__)
  }
  
  module.hot.accept("./KnowledgebaseEdit.vue?vue&type=template&id=8046ec40", () => {
    api.rerender('8046ec40', render)
  })

}


export default __exports__